<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-default shape-skew response bg-gradient">
            </div>
        </section>
        <section class="section-skew" :style="oracle.isMobile() ? 'margin-top: -150px' : 'margin-top: 30px'"
                 v-if="profile != null">
            <div :class="!oracle.isMobile() ? 'container mt--100' : 'container'">
                <card shadow :class="!oracle.isMobile() ?'card-profile mt--300' : 'card-profile'" no-body>
                    <div class="px-4">
                        <div class="row justify-content-center">
                            <div class="col-lg-4 order-lg-2">
                                <div class="card-profile-image align-center justify-center ml-auto mr-auto">
                                    <img v-if="profile.lawyer_cover == null || profile.lawyer_cover.length == 0"
                                         :src="require('@/assets/image/user_avatar.png')"
                                         class="card-profile-image rounded-circle center_cropped">
                                    <img v-else :src="profile.lawyer_cover != null ? profile.lawyer_cover :
                                 require('@/assets/image/user_avatar.png')"
                                         class="card-profile-image rounded-circle center_cropped">
                                </div>
                                <label for="uploaduser" class="fa fa-plus-circle display-1 pick-image"></label>
                            </div>
                            <base-button v-if="!oracle.isMobile()" tag="span"
                                         style="position: absolute; top: 0; right: 0"
                                         @click="showExit"
                                         class="m-3"
                                         type="danger"
                                         icon="fa fa-sign-out">
                                {{language.lang("Log out")}}
                            </base-button>
                            <div v-if="!oracle.isMobile()" :class="'m-3 ' + (isEN ? '' : 'text-left')"
                                 style="position: absolute; top: 0; left: 0; display: flex; flex-direction: row; direction: ltr; opacity: 0">
                                <div class="flex-column text-left">
                                    <h3 class="font-weight-bold">{{oracle.format(profile.lawyer_views)}}</h3>
                                    <span class="description">{{language.lang('View')}}</span>
                                </div>
                                <div class="flex-column ml-5">
                                    <h3 class="font-weight-bold">{{oracle.format(profile.attraction)}}</h3>
                                    <span class="description">{{language.lang('Click')}}</span>
                                </div>
                                <div class="flex-column ml-5">
                                    <h3 class="font-weight-bold">{{oracle.format(profile.auth_version)}}</h3>
                                    <span class="description">{{language.lang('Logged In')}}</span>
                                </div>
                                <div class="flex-column ml-5 text-left">
                                    <h3 class="font-weight-bold">{{oracle.format(profile.lawyer_voters)}}</h3>
                                    <span class="description">{{language.lang('Reviews')}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="text-center" style="margin-top: -20px; position: relative">
                            <h3 class="mr-auto ml-auto text-center font-weight-bold">{{profile.lawyer_title}}</h3>
                            <h6 class="mr-auto ml-auto text-center">{{"@" + profile.username}}</h6>
                            <div v-if="oracle.isMobile()" :class="'mt-5 mb-5 ' + (isEN ? '' : 'text-center')"
                                 style="display: flex; flex-direction: row; direction: ltr; margin-right: auto; margin-left: auto; opacity: 0">
                                <div class="flex-column mr-auto ml-auto">
                                    <h3 class="font-weight-bold">{{oracle.format(profile.lawyer_views)}}</h3>
                                    <span class="description">{{language.lang('View')}}</span>
                                </div>
                                <div class="flex-column mr-auto ml-auto">
                                    <h3 class="font-weight-bold">{{oracle.format(profile.attraction)}}</h3>
                                    <span class="description">{{language.lang('Click')}}</span>
                                </div>
                                <div class="flex-column mr-auto ml-auto">
                                    <h3 class="font-weight-bold">{{oracle.format(profile.auth_version)}}</h3>
                                    <span class="description">{{language.lang('Logged In')}}</span>
                                </div>
                                <div class="flex-column mr-auto ml-auto">
                                    <h3 class="font-weight-bold">{{oracle.format(profile.lawyer_voters)}}</h3>
                                    <span class="description">{{language.lang('Reviews')}}</span>
                                </div>
                            </div>
                            <div v-if="profile.lawyer_contact_public != null"
                                 class="row mt-3 mb-3 mr-auto ml-auto text-default">
                                <div class="ml-auto"></div>
                                <i @click="oracle.newTab(profile.lawyer_contact_public.facebook)"
                                   v-if="!oracle.isEmpty(profile.lawyer_contact_public.facebook)"
                                   style="width: 25px; height: 25px; font-size: 20px"
                                   class="m-1 fa fa-facebook badge-circle"></i>
                                <i @click="oracle.newTab(profile.lawyer_contact_public.twitter)"
                                   v-if="!oracle.isEmpty(profile.lawyer_contact_public.twitter)"
                                   style="width: 25px; height: 25px; font-size: 20px"
                                   class="m-1 fa fa-twitter badge-circle"></i>
                                <i @click="oracle.newTab(profile.lawyer_contact_public.instagram)"
                                   v-if="!oracle.isEmpty(profile.lawyer_contact_public.instagram)"
                                   style="width: 25px; height: 25px; font-size: 20px"
                                   class="m-1 fa fa-instagram badge-circle "></i>
                                <i @click="oracle.newTab(profile.lawyer_contact_public.youtube)"
                                   v-if="!oracle.isEmpty(profile.lawyer_contact_public.youtube)"
                                   style="width: 25px; height: 25px; font-size: 20px"
                                   class="m-1 fa fa-youtube badge-circle "></i>
                                <div class="mr-auto"></div>
                            </div>
                        </div>
                        <div class="mt-5">
                            <input type="file"
                                   accept="image/*"
                                   @change="onFileChange"
                                   id="uploaduser"/>
                            <div style="text-align: center">
                            </div>
                            <div :class="oracle.isMobile() ? '' : 'd-flex flex-row border-top'"
                                 v-if="profile.lawyer_state == 1">
                                <v-tabs background-color="#eeeeee" :hide-slider="!isEN && !oracle.isMobile()"
                                        :vertical="!oracle.isMobile()" grow :show-arrows="false" align-with-title
                                        v-model="tabs"
                                        color="gray"
                                        :style="oracle.isMobile() ? '' : 'width: 120px !important; max-width: 120px; min-width: 120px;'"
                                        style="font-size: 11px; font-weight: bold;">
                                    <v-tab :style="oracle.isMobile() ? '' : 'height: 48px !important; max-height: 48px !important;'"
                                           style="font-size: 11px; font-weight: bold; border-bottom: #ffffff 1px solid"
                                           v-for="n in items"
                                           :key="n">
                                        {{ n }}
                                    </v-tab>
                                </v-tabs>
                                <v-tabs-items style="min-height: 500px" class="mt-3 flex" v-model="tabs">
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <Edit/>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <Visit :lawyer="profile"></Visit>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <Client :lawyer="profile"></Client>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <Prices :lawyer="profile" :is-lawyer="true"></Prices>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <Reviews :lawyer="profile"></Reviews>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <Message></Message>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs-items>
                            </div>
                            <div class="flex-column mt-3 mb-5" v-else-if="profile.lawyer_state == 0">
                                <i class="fa fa-hourglass-1 display-3" style="color: #427BD5"></i>
                                <h6 class="font-weight-bold mt-2">
                                    {{language.lang(
                                    'Your request is processing, we will contact you when your registration is completed.'
                                    )}}</h6>
                            </div>
                            <div class="flex-column mt-3 mb-5" v-else-if="profile.lawyer_state == 2">
                                <i class="fa fa-warning display-3" style="color: #f6617e"></i>
                                <h6 class="font-weight-bold mt-2">
                                    {{language.lang(
                                    'Unfortunately your request has been rejected, please contact us formore information.'
                                    )}}</h6>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <v-dialog scrollable width="500" v-model="showContract">
            <v-card>
                <v-card-text>
                    <div class="d-flex flex-column mt-3 mb-3">
                        <div v-if="selectedClient != null" class="d-flex flex-column">
                            <v-text-field
                                    persistent-hint
                                    disabled
                                    v-model="selectedClient.username"
                                    :label="language.lang('Client')"
                            ></v-text-field>
                            <v-select :items="plans"
                                      item-text="plan_title"
                                      item-value="plan_id"
                                      v-model="contract.plan_id"
                                      :label="language.lang('Plan Name')"
                                      :hint="language.lang('Select the plan type')"
                                      persistent-hint>

                            </v-select>
                            <v-text-field
                                    persistent-hint
                                    type="number"
                                    :hint="language.lang('In Dollars')"
                                    v-model="contract.total"
                                    :label="language.lang('Total contract price')"
                            ></v-text-field>
                            <v-text-field
                                    persistent-hint
                                    type="number"
                                    :hint="language.lang('In Dollars')"
                                    v-model="contract.total_payed"
                                    :label="language.lang('Paid amount')"
                            ></v-text-field>
                            <v-text-field
                                    persistent-hint
                                    type="number"
                                    :hint="language.lang('In Dollars')"
                                    v-model="contract.current_installment"
                                    :label="language.lang('Current installment')"
                            ></v-text-field>
                            <v-select :items="contract_steps"
                                      v-model="contract.state"
                                      item-text="abbr"
                                      item-value="state"
                                      :hint="language.lang('Set client state')"
                                      persistent-hint>
                            </v-select>
                        </div>
                        <div v-else class="d-flex flex-column">
                            <span class="font-weight-bold" style="font-size: 17px">{{language.lang('Create a new client')}}</span>
                            <p style="font-size: 12px">{{language.lang(
                                'Create a new client if it is not exists in our database.'
                                )}}</p>
                            <v-text-field class="mt-3"
                                          persistent-hint
                                          v-model="newUsername"
                                          :label="language.lang('Client\'s First name and last name')"
                            ></v-text-field>
                            <v-text-field
                                    persistent-hint
                                    v-model="newPhoneNumber"
                                    :label="language.lang('Client\'s Email or 11 digits phone number')"
                            ></v-text-field>
                            <v-select :items="steps"
                                      v-model="newState"
                                      item-text="abbr"
                                      item-value="state"
                                      :hint="language.lang('Set client state')"
                                      persistent-hint>
                            </v-select>
                            <v-textarea
                                    :label="language.lang('Brief details about the current progress')"
                                    v-model="newNote">
                            </v-textarea>
                            <v-file-input v-model="attachment"
                                          :label="language.lang('Attachment (Resume/CV)')" persistent-hint
                                          :hint="'pdf, docx, xls, png, jpg, txt'">
                            </v-file-input>
                            <v-progress-circular :style="loading ? 'opacity: 1' : 'opacity: 0'"
                                                 class="mr-auto ml-auto mt-3 mb-3"
                                                 indeterminate></v-progress-circular>
                        </div>
                    </div>
                    <base-button tag="span" @click="showContract = false"
                                 type="secondary" class="mb-2 mt-2">
                        {{language.lang('Discard')}}
                    </base-button>
                    <base-button v-if="!loading" tag="span" @click="saveContact"
                                 type="primary" class="mb-2 mt-2 mr-2 ml-2">
                        {{language.lang('Save contract')}}
                    </base-button>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";
    import Edit from "@/views/lawyer/Edit";
    import Message from "@/views/lawyer/Message";
    import Prices from "@/views/lawyer/Prices";
    import Reviews from "@/views/lawyer/Reviews";
    import Client from "@/views/lawyer/Client";
    import Visit from "@/views/lawyer/Visit";

    export default {
        components: {
            Visit,
            Client,
            Reviews,
            Prices,
            Edit,
            Message,
        },
        data() {
            return {
                loading: false,
                record_detail: {},
                attachment: null,
                language: language,
                contract: {},
                plans: [],
                newUsername: null,
                newPhoneNumber: null,
                newNote: null,
                newState: 0,
                selectedClient: null,
                profile: null,
                showContract: false,
                oracle: oracle,
                isEN: oracle.isEN(),
                tabs: null,
                steps: [
                    {state: 0, abbr: language.lang('Pending')},
                    {state: 1, abbr: language.lang('Cancel')},
                    {state: 2, abbr: language.lang('Contract')},
                    {state: 3, abbr: language.lang('No reply')},
                ],
                items: [
                    language.lang('Profile'),
                    language.lang('Visits'),
                    language.lang('Clients'),
                    language.lang('Prices'),
                    language.lang('Reviews'),
                    language.lang('Inbox'),
                ],
                contract_steps: [
                    {state: 0, abbr: language.lang('Consultation')},
                    // {state: 1, abbr: language.lang('Select a immigration consultant')},
                    {state: 2, abbr: language.lang('Send initial documents by the user')},
                    {state: 3, abbr: language.lang('Pay the first installment')},
                    {state: 4, abbr: language.lang('signing agreement')},
                    {
                        state: 5,
                        abbr: language.lang('Sending the required documents for the desired immigration program by the user')
                    },
                    {state: 6, abbr: language.lang('Receipt and approval of documents by a consultant')},
                    {state: 7, abbr: language.lang('Ongoing case')},
                    {state: 8, abbr: language.lang('Receive approvals and acceptance')},
                    {state: 9, abbr: language.lang('Pay the second installment')},
                    {state: 10, abbr: language.lang('Sending the required documents for the visa by the client')},
                    {state: 11, abbr: language.lang('Receipt and approval of documents by a consultant')},
                    {state: 12, abbr: language.lang('Send documents to the Immigration Office to obtain a visa')},
                    {state: 13, abbr: language.lang('Receive a fingerprint letter')},
                    {state: 14, abbr: language.lang('Determine the time of fingerprinting')},
                    {state: 15, abbr: language.lang('Get the result of fingerprinting')},
                    {state: 16, abbr: language.lang('Get a visa result')},
                    {state: 17, abbr: language.lang('Send a passport to get a visa')},
                    {state: 18, abbr: language.lang('Ticket purchase')},
                    {state: 19, abbr: language.lang('Preparation of accommodation and arrangements for arrival')},
                    {state: 20, abbr: language.lang('Review the case and decide whether to take action again')},
                ],
            }
        },
        methods: {
            showExit() {
                oracle.showMessage(language.lang('Are you sure to exit?'), language.lang('Yes, Log me out'), () => {
                    oracle.logOut()
                    this.$router.push('/')
                })
            },
            onFileChange(e) {
                let file = e.target.files[0];
                oracle.axiosUpload(file, (response) => {
                    let model = {lawyer_cover: response.data};
                    oracle.axios("lawyer/edit", model, (res) => {
                        this.profile.lawyer_cover = response.data
                    });
                });
            }, saveContact() {
                this.loading = true
                if (this.attachment != null) {
                    oracle.axiosUpload(this.attachment, (res) => {
                        this.record_detail = {}
                        this.record_detail.resume = [res.data]
                        this.attachment = null
                        this.saveContact()
                    }, () => {
                        this.loading = false
                    })
                    return
                }
                if (this.selectedClient != null) {
                    this.contract.user_id = this.selectedClient.user_id
                } else {
                    this.contract.username = this.newUsername
                    this.contract.identity = this.newPhoneNumber
                    this.contract.state = this.newState
                    this.contract.note = this.newNote
                    this.contract.record_detail = this.record_detail
                }
                oracle.axios('plan/subscribe', this.contract, (res) => {
                    this.contract = {}
                    this.showContract = false
                    if (this.selectedClient == null) {
                        oracle.showMessage(language.lang("Client has been created successfully and will be shown after review by the administrator."), null, null, 'checked')
                    } else {
                        oracle.showMessage(language.lang("Contract has been created successfully, you can now modify it under 'Clients'."), null, null, 'checked')
                    }
                    oracle.send(oracle.UPDATE)
                    this.loading = false
                    this.fetch()
                }, () => {
                    this.loading = false
                })
            }, createContract(item) {
                this.loading = false
                this.record_detail = {}
                this.newPhoneNumber = null
                this.newUsername = null
                this.newState = 0
                this.newNote = null
                this.attachment = null
                this.selectedClient = item
                this.showContract = true
            }
        },
        mounted() {
            oracle.axios("lawyer/getProfile", null, (response) => {
                this.profile = response.data;
                oracle.axios('plan/getList', {parent_by: this.profile.lawyer_id, limit_by: 1000}, (res) => {
                    this.plans = res.data
                })
            });
            oracle.receive(oracle.CONTRACT, (item) => {
                this.createContract(item != null ? item.user : null)
            })
        }
    };
</script>
<style>
    .uploadAvatar {
        position: absolute;
        right: 2px;
        bottom: 0;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 25px;
        background: #fff;
    }

    .uploadAvatar .v-icon {
        font-size: 30px !important;
        color: #42C7D5 !important;
    }

    input[type="file"] {
        display: none;
    }

    .contentProfile {
        max-height: 55%;
        margin-bottom: 20px;
    }

    .itemsProfile {
        margin-top: 20px;
        max-height: 65vh;
        overflow: auto;
        margin-bottom: 1em;
    }

    .itemProfile a,
    .itemExit {
        display: flex;
        justify-content: space-between;
        padding: 10px 20px;
        color: #000;
        font-size: 12px;
    }

    .itemProfile a .v-icon,
    .itemExit .v-icon {
        color: #000;
        font-size: 15px;
    }

    .pick-image {
        position: absolute;
        right: 100px;
        bottom: 85px;
        color: #427BD5;
        text-align: center;
        align-self: center;
        align-items: center;
        justify-items: center;
        justify-self: center;
        line-height: 0 !important;
    }

    .pick-image::before {
        width: 50px;
        height: 50px;
        border-radius: 50px;
        background: white;
        line-height: 0;
    }

    .message-empty-profile {
        margin-top: 50px;
        margin-bottom: 50px;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .message-empty-profile .v-icon {
        font-size: 4.5em;
    }

    .message-empty-profile p {
        font-size: 13px;
    }
</style>
